module.exports = __webpack_public_path__ + "static/media/founder-avatar.5f286716.jpg";